import { useClerk } from '@clerk/clerk-react';
import { ShieldAlert } from 'lucide-react';
import Button from '../../components/Button';

export default function UnauthorizedPage() {
    const { signOut } = useClerk();

    return (
        <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
            <div className="text-center max-w-md">
                <div className="rounded-full bg-red/10 p-6 inline-block mb-6">
                    <ShieldAlert size={64} className="text-red" />
                </div>

                <h1 className="text-3xl font-bold mb-4">Access Denied</h1>

                <p className="text-muted-light dark:text-muted-dark mb-8">
                    Your account is not authorized to access the admin panel.
                    Please contact a super administrator if you believe this is an error.
                </p>

                <Button onClick={() => signOut()} variant="primary">
                    Sign Out
                </Button>
            </div>
        </div>
    );
}

